import { GridHeaders, GridHeadersNoWidth } from '@project-types/GridHeaders';
import { MainReportGridData } from '@pages/reporting-pages/deliveries-main/types/MainReportGridData';
import { MainTransportTypes } from '@api/order-reporting/types-deliveries/CountryDeliveriesSummaryReport';



export const headersObject: GridHeaders<MainReportGridData> = [
	{ label: 'Stát', key: 'country', width: 'auto' },
	{ label: 'Depo', key: 'executionPlaceName', width: 'auto' },
	
	{ label: 'Objem [hl]', key: 'sd_volume', width: '1fr' },
	{ label: 'Váha [t]', key: 'sd_weight', width: '1fr' },
	{ label: 'Váha vratky [t]', key: 'sd_returnsWeight', width: '1fr' },
	{ label: 'Počet objednávek', key: 'sd_ordersCount', width: '1fr' },

	{ label: 'Objem [hl]', key: 'int_volume', width: '1fr' },
	{ label: 'Váha [t]', key: 'int_weight', width: '1fr' },
	{ label: 'Váha vratky [t]', key: 'int_returnsWeight', width: '1fr' },
	{ label: 'Počet objednávek', key: 'int_ordersCount', width: '1fr' },

	{ label: 'Objem [hl]', key: 'dd_volume', width: '1fr' },
	{ label: 'Váha [t]', key: 'dd_weight', width: '1fr' },
	{ label: 'Váha vratky [t]', key: 'dd_returnsWeight', width: '1fr' },
	{ label: 'Počet objednávek', key: 'dd_ordersCount', width: '1fr' },

	{ label: 'Objem [hl]', key: 'td_volume', width: '1fr' },
	{ label: 'Váha [t]', key: 'td_weight', width: '1fr' },
	{ label: 'Váha vratky [t]', key: 'td_returnsWeight', width: '1fr' },
	{ label: 'Počet objednávek', key: 'td_ordersCount', width: '1fr' },
]


// first header for download to csv
export const tableHeaders: GridHeadersNoWidth<MainReportGridData> = [
	{ label: '', key: 'country' },
	{ label: '', key: 'executionPlaceName' },
	
	{ label: MainTransportTypes.sd, key: 'sd_volume' },
	{ label: '', key: 'sd_weight' },
	{ label: '', key: 'sd_returnsWeight' },
	{ label: '', key: 'sd_ordersCount' },

	{ label: MainTransportTypes.int, key: 'int_volume' },
	{ label: '', key: 'int_weight' },
	{ label: '', key: 'int_returnsWeight' },
	{ label: '', key: 'int_ordersCount' },

	{ label: MainTransportTypes.dd, key: 'dd_volume' },
	{ label: '', key: 'dd_weight' },
	{ label: '', key: 'dd_returnsWeight' },
	{ label: '', key: 'dd_ordersCount' },

	{ label: MainTransportTypes.td, key: 'td_volume' },
	{ label: '', key: 'td_weight' },
	{ label: '', key: 'td_returnsWeight' },
	{ label: '', key: 'td_ordersCount' },
]


// second header for download to csv
export const headersAsValues = headersObject.reduce((acc, header) => {
	if (!header || !header.key) return acc;
	acc[header.key] = header.label;
	return acc;
}, {} as Record<keyof MainReportGridData, string>)